// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Icon$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as ViewUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ViewUtils.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as FooterActions$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/FooterActions.bs.js";

function getPpSubscriptionCTAs(workspace_dispatch, tab) {
  return ButtonUtils$Catalyst.getDefaultButtonProps({
              TAG: /* Text */0,
              _0: "View More"
            }, undefined, (function (param) {
                return Curry._2(workspace_dispatch.addTab, tab, false);
              }), undefined, Caml_option.some(React.createElement(Icon$Catalyst.NavigateIcon.make, {
                      fontSize: "Default"
                    })), undefined, undefined, undefined, undefined, undefined);
}

function makeActions(msisdn, subscription_logs, workspace_dispatch) {
  if (List.length(subscription_logs) > 1) {
    return {
            hd: getPpSubscriptionCTAs(workspace_dispatch, {
                  TAG: /* PremiumPartnerReport */39,
                  msisdn: msisdn
                }),
            tl: /* [] */0
          };
  } else {
    return /* [] */0;
  }
}

function PpAccordionFooter(Props) {
  var msisdn = Props.msisdn;
  var premiumPartnerReport = Props.premiumPartnerReport;
  var workspace_dispatch = Props.workspace_dispatch;
  var data = ViewUtils$Catalyst.extractLiveData(premiumPartnerReport);
  if (data !== undefined) {
    return React.createElement(FooterActions$Catalyst.make, {
                actions: makeActions(msisdn, data.subscription_logs, workspace_dispatch)
              });
  } else {
    return null;
  }
}

var make = PpAccordionFooter;

export {
  getPpSubscriptionCTAs ,
  makeActions ,
  make ,
  
}
/* react Not a pure module */
